import script from "./BaseTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplate.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplate.vue?vue&type=style&index=0&id=8b4e62ae&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b4e62ae"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
